<template>
  <div class="flex flex-wrap paddig-responsive">
    <div class="flex w-full text-left center-responsive">
      <h2>{{ $t("sport_highest_level_compete_question", { sport: getSportLabel(Sport.TENIS)}) }}</h2>
    </div>
    <div class="flex w-full mt-8">
      <div class="flex flex-col">
        <template v-for="option in options" :key="option.id">
          <label class="flex items-center mb-2">
            <input type="radio" :value="option.value" v-model="levelCompeted" @change="showValue()" class="mr-2">
            <span>{{ option.label }}</span>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SelectOption } from "@/custom-models/levelingSelector";
import { getSportLabel } from "@/helpers/dataHelper";
import { Sport } from "@/enum/constants";
  
export default defineComponent({
  name: 'LevelCompetedSelector',
  props: {
    propLevelCompeted:{ 
      type: Number,
      default: 0.4 
    }
  },
  created (){
    this.levelCompeted = this.propLevelCompeted;
  },
  data() {
    return {
      Sport:Sport,
      levelCompeted: 0.4,
      options: [
        { id: 1, label: this.$t("national"), value: 0.4 },
        { id: 2, label: this.$t("regional"), value: 0.2 },
        { id: 3, label: this.$t("club"), value: 0.1 },
        { id: 4, label: this.$t("no_compete"), value: 0.0 },
      ] as SelectOption[]
    };
  },
  methods: {
    getSportLabel,
    showValue() {
      this.$emit("selectedlevelCompeted", this.levelCompeted);
    }
  }
});
</script>